import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/auth/auth.service';
import { LoginForm } from 'src/app/shared/models/auth/login-form.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-development-panel',
  templateUrl: './development-panel.component.html',
  styleUrls: ['./development-panel.component.scss'],
})
export class DevelopmentPanelComponent implements OnInit {
  developmentAccounts = environment.developmentAccounts;
  isLoggedIn$;
  isExpanded = false;
  constructor(private authService: AuthService, private router: Router) {
    this.isLoggedIn$ = this.authService.isLoggedIn$;
  }

  ngOnInit() {}

  loginAs(account) {
    const loginForm = new LoginForm(account.email, account.password);
    this.authService
      .login(loginForm)
      .subscribe(_ => this.router.navigate(['/']));
  }

  logout() {
    this.authService.logout().subscribe();
  }
}
